import i18next from 'i18next';

export const getUserOptions = (users) => {
    const items = users.map((item) => {
        return {
            label: `${item.first_name} ${item.last_name}`,
            value: item.id,
        };
    });

    return [
        {
            disabled: true,
            label: i18next.t('Select an user'),
            value: '',
        },
        {
            label: i18next.t('No user assigned'),
            value: 'DO_NOT_ASSIGN',
        },
        ...items,
    ];
};
